/**
 * Cart drawer bundle upsell — add matching accessories via Cart AJAX API,
 * then refresh through Impulse's existing ajaxProduct:added → CartForm.buildCart path.
 */
(function () {
  'use strict';

  var ADDING_LABEL = 'ADDING';
  var ERROR_MESSAGE = 'Could not add items. Please try again.';
  var SUCCESS_MESSAGE = 'Added to cart.';
  var isSubmitting = false;

  function getStatusEl(root) {
    return root ? root.querySelector('[data-bundle-upsell-status]') : null;
  }

  function setStatus(root, message, isError) {
    var status = getStatusEl(root);
    if (!status) return;

    status.textContent = message || '';
    if (message) {
      status.classList.remove('visually-hidden');
      if (isError) {
        status.setAttribute('role', 'alert');
      } else {
        status.removeAttribute('role');
      }
    } else {
      status.classList.add('visually-hidden');
      status.removeAttribute('role');
    }
  }

  function parseVariantIds(raw) {
    if (!raw) return [];
    return String(raw)
      .split(',')
      .map(function (id) {
        return parseInt(id, 10);
      })
      .filter(function (id) {
        return !isNaN(id) && id > 0;
      });
  }

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) {
      return theme.routes.cartAdd;
    }
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = ADDING_LABEL;
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = btn.getAttribute('data-default-label') || btn.textContent;
    }
  }

  function refreshCartDrawer() {
    // Impulse theme.CartDrawer listens for ajaxProduct:added and calls cartForm.buildCart()
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  function handleAdd(btn) {
    if (isSubmitting || !btn || btn.disabled) return;

    var root = btn.closest('[data-cart-bundle-upsell]');
    var variantIds = parseVariantIds(btn.getAttribute('data-variant-ids'));

    if (!variantIds.length) {
      setStatus(root, ERROR_MESSAGE, true);
      return;
    }

    isSubmitting = true;
    setButtonLoading(btn, true);
    setStatus(root, 'Adding items…', false);

    var payload = {
      items: variantIds.map(function (id) {
        return { id: id, quantity: 1 };
      })
    };

    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, status: response.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status === 422) {
          var msg =
            (result.data && (result.data.description || result.data.message)) ||
            ERROR_MESSAGE;
          throw new Error(msg);
        }

        setStatus(root, SUCCESS_MESSAGE, false);
        refreshCartDrawer();
      })
      .catch(function (err) {
        setButtonLoading(btn, false);
        setStatus(root, (err && err.message) || ERROR_MESSAGE, true);
      })
      .finally(function () {
        isSubmitting = false;
      });
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-bundle-upsell-add]');
    if (!btn) return;
    evt.preventDefault();
    handleAdd(btn);
  });
})();
